import { useEffect, useRef } from "react";

const useHandleResize = () => {

    const windowSize = useRef({ width: 0, height: 0 });

    const handleResize = () => {
        windowSize.current = { width: window.innerWidth, height: window.innerHeight };
    };

    useEffect(() => {
        windowSize.current.width = window.innerWidth
        windowSize.current.height = window.innerHeight

        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return { windowSize };
}

export default useHandleResize;